import React, { Component } from 'react';
import './App.css';
import Header from './Header/Header.js'
import Menu from './Menu/Menu.js'
import Content from './Content/Content.js'
import Footer from './Footer/Footer.js'

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mainState: "home",
      headerHeight: 0,
      scrollTop: 0
    };
  }
  componentDidMount(){
    window.onscroll = ()=>{
      this.setState(scrollTop => {
        return{scrollTop: Math.floor(document.scrollingElement.scrollTop)}
      });
    }
  }
  changePage = (curr) => {
    this.setState(prevState => {
      return{mainState: curr}
    });
  }

  setHeight = (height) => {
    this.setState(prevState => {
      return{headerHeight: height}
    });
  }

  render() {
    return (
      <div>
        <Header updateHeight={(height)=>this.setHeight(height)} />
        <Menu mainState={this.state.mainState} changeSelection={(curr)=>this.changePage(curr)}
              headerHeight={this.state.headerHeight} scrollTop={this.state.scrollTop}/>
        <Content mainState={this.state.mainState} />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js